const isProduction = process.env.NODE_ENV === "production";
process.env.NODE_ENV === "development";
export {
  isProduction
};
